// Initialize tabs functionality
document.addEventListener('DOMContentLoaded', function() {
    // Add data attributes and classes to tab elements
    document.querySelectorAll('ul.tabs li').forEach((tab, i) => {
        tab.setAttribute('data-tab', 'tabbed-content-' + i);
        tab.classList.add('tablinks');
        
        // Add SVG plus icon
        tab.insertAdjacentHTML('beforeend', `
            <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-plus plus" width="10" height="10" viewBox="0 0 160 160">
                <rect class="vertical-line" x="70" width="20" height="160"/>
                <rect class="horizontal-line" y="70" width="160" height="20"/>
            </svg>
        `);
    });

    // Add IDs to content elements
    document.querySelectorAll('.tabs-content li').forEach((content, i) => {
        content.id = 'tabbed-content-' + i;
    });

    // Clone content into tabs
    document.querySelectorAll('ul.tabs li').forEach(tab => {
        const clonedDiv = tab.getAttribute('data-tab');
        const newAmount = document.getElementById(clonedDiv).innerHTML;
        tab.insertAdjacentHTML('beforeend', `<ul class="tab-content"><li>${newAmount}</li></ul>`);
    });

    // Handle tab clicks
    const tabsList = document.querySelector('ul.tabs');
    document.querySelectorAll('ul.tabs li').forEach(tab => {
        tab.addEventListener('click', function(event) {
            event.stopPropagation();

            // Hide all tab content
            document.querySelectorAll('.tab-content').forEach(content => {
                content.style.display = 'none';
            });

            const parent = this.children[0];
            
            if (parent.classList.contains('current')) {
                parent.classList.remove('current');
                return;
            }

            document.querySelectorAll('ul.tabs li svg').forEach(icon => {
                    icon.classList.remove('current');
                
            });

            parent.classList.add('current');
            const tabContent = this.querySelector('.tab-content');
            if (tabContent) {
                tabContent.style.display = 'block';
                tabContent.style.opacity = '0';
                setTimeout(() => {
                    tabContent.style.opacity = '1';
                }, 0);
            }
        });
    });

    // Handle clicks outside tabs
    document.body.addEventListener('click', function(e) {
        e.stopPropagation();
        if (!e.target.closest('.product__description')) {
            const currentTab = document.querySelector('ul.tabs .current');
            if (currentTab) {
                currentTab.click();
            }
        }
    });

    // Prevent propagation for links within tab content
    document.querySelectorAll('.tab-content li p span a').forEach(link => {
        ['click', 'touchstart'].forEach(eventType => {
            link.addEventListener(eventType, (e) => {
                e.stopPropagation();
            });
        });
    });

    // Move slider buttons
    const sliderButtons = document.querySelectorAll('.grid__item .product__image-slider .flickity-button');
    if (sliderButtons.length > 0) {
        const buttonWrap = document.createElement('div');
        buttonWrap.className = 'button-wrap';
        sliderButtons.forEach(button => buttonWrap.appendChild(button));
        
        const imageSlider = document.querySelector('.grid__item .product__image-slider');
        if (imageSlider) {
            imageSlider.appendChild(buttonWrap);
        }
    }
});